import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { useAuth } from '@/auth/useAuth';
import { extractErrorMessage } from '@/features/shared/utils/errorMessage';
const LoginForm = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const { login } = useAuth(); // ✅ récupération via le contexte
    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        setLoading(true);
        try {
            const result = await login(email, password);
            if (result === 'NEED_2FA') {
                navigate('/verify-2fa', { replace: true });
            }
            else if (result === 'SUCCESS') {
                navigate('/tasks', { replace: true });
            }
        }
        catch (err) {
            // Afficher uniquement le message d'erreur renvoyé par le backend (error.message)
            setError(extractErrorMessage(err));
        }
        finally {
            setLoading(false);
        }
    };
    return (_jsxs("div", { className: "flex min-h-full flex-col justify-center px-6 py-12 lg:px-8", children: [_jsxs("div", { className: "sm:mx-auto sm:w-full sm:max-w-sm", children: [_jsx("img", { className: "mx-auto h-40 w-auto", src: "/images/logo-utemaf.png", alt: "UTEMAF" }), _jsx("h2", { className: "mt-10 text-center text-2xl/9 font-bold tracking-tight text-gray-900", children: "Connexion" }), error && _jsx("p", { className: "text-red-500 text-sm mb-2", children: error })] }), _jsx("div", { className: "mt-10 sm:mx-auto sm:w-full sm:max-w-sm", children: _jsxs("form", { onSubmit: handleSubmit, className: "space-y-6", children: [_jsxs("div", { children: [_jsx("label", { htmlFor: "email", className: "block text-sm", children: "Email" }), _jsx("input", { id: "email", type: "email", value: email, onChange: (e) => setEmail(e.target.value), className: "w-full border px-3 py-2 rounded", required: true })] }), _jsxs("div", { children: [_jsxs("div", { className: "flex items-center justify-between", children: [_jsx("label", { htmlFor: "password", className: "block text-sm/6 font-medium text-gray-900", children: "Password" }), _jsx("div", { className: "text-sm", children: _jsx(Link, { to: "/forgot-password", className: "font-semibold text-indigo-600 hover:text-indigo-500", children: "Mot de passe oubli\u00E9?" }) })] }), _jsx("input", { type: "password", value: password, onChange: (e) => setPassword(e.target.value), className: "w-full border px-3 py-2 rounded", required: true })] }), _jsx("button", { type: "submit", disabled: loading, className: "w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700", children: loading ? 'Connexion...' : 'Se connecter' })] }) })] }));
};
export default LoginForm;
